
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RepatriationOpportunityBriefResource,
  RepatriationOpportunityResource,
} from '../models';
import {
    RepatriationOpportunityBriefResourceFromJSON,
    RepatriationOpportunityBriefResourceToJSON,
    RepatriationOpportunityResourceFromJSON,
    RepatriationOpportunityResourceToJSON,
} from '../models';

export interface CloseRepatriationOpportunityRequest {
    repatriationId: string;
}

export interface GetRepatriationOpportunityRequest {
    repatriationId: string;
}

export interface GetRepatriationOpportunityBriefRequest {
    repatriationId: string;
}

/**
 * 
 */
export class RepatriationOpportunitiesApi extends runtime.BaseAPI {

    /**
     * Close repatriation opportunity by id
          */
    async closeRepatriationOpportunityRaw(requestParameters: CloseRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityResource>> {
        if (requestParameters['repatriationId'] == null) {
            throw new runtime.RequiredError(
                'repatriationId',
                'Required parameter "repatriationId" was null or undefined when calling closeRepatriationOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RepatriationOpportunityResource>({
            path: `/repatriation-opportunity/api/repatriation-opportunity/{repatriationId}/close`.replace(`{${"repatriationId"}}`, encodeURIComponent(String(requestParameters['repatriationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Close repatriation opportunity by id
          */
    async closeRepatriationOpportunity(requestParameters: CloseRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityResource> {
        const response = await this.closeRepatriationOpportunityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get repatriation opportunity by id
          */
    async getRepatriationOpportunityRaw(requestParameters: GetRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityResource>> {
        if (requestParameters['repatriationId'] == null) {
            throw new runtime.RequiredError(
                'repatriationId',
                'Required parameter "repatriationId" was null or undefined when calling getRepatriationOpportunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RepatriationOpportunityResource>({
            path: `/repatriation-opportunity/api/repatriation-opportunity/{repatriationId}`.replace(`{${"repatriationId"}}`, encodeURIComponent(String(requestParameters['repatriationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get repatriation opportunity by id
          */
    async getRepatriationOpportunity(requestParameters: GetRepatriationOpportunityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityResource> {
        const response = await this.getRepatriationOpportunityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the project brief of a repatriation opportunity as seen by the invited freelancer
          */
    async getRepatriationOpportunityBriefRaw(requestParameters: GetRepatriationOpportunityBriefRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityBriefResource>> {
        if (requestParameters['repatriationId'] == null) {
            throw new runtime.RequiredError(
                'repatriationId',
                'Required parameter "repatriationId" was null or undefined when calling getRepatriationOpportunityBrief().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RepatriationOpportunityBriefResource>({
            path: `/repatriation-opportunity/api/repatriation-opportunity/{repatriationId}/brief`.replace(`{${"repatriationId"}}`, encodeURIComponent(String(requestParameters['repatriationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityBriefResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the project brief of a repatriation opportunity as seen by the invited freelancer
          */
    async getRepatriationOpportunityBrief(requestParameters: GetRepatriationOpportunityBriefRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityBriefResource> {
        const response = await this.getRepatriationOpportunityBriefRaw(requestParameters, initOverrides);
        return response._data;
    }

}
